import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";

const data = [
  { customer: "John Odhiambo", branch: "Nairobi CBD", loanId: "LN-4021", totalDue: "KES 25,000", paid: "KES 18,500", balance: "KES 6,500", date: "2026-02-28", status: "Partial" },
  { customer: "Mary Achieng", branch: "Westlands", loanId: "LN-4035", totalDue: "KES 15,000", paid: "KES 9,200", balance: "KES 5,800", date: "2026-02-27", status: "Partial" },
  { customer: "Ali Mohamed", branch: "Mombasa", loanId: "LN-4042", totalDue: "KES 30,000", paid: "KES 22,000", balance: "KES 8,000", date: "2026-02-26", status: "Partial" },
  { customer: "Rose Wambui", branch: "Kisumu", loanId: "LN-4058", totalDue: "KES 12,000", paid: "KES 7,500", balance: "KES 4,500", date: "2026-02-25", status: "Partial" },
  { customer: "David Kiprono", branch: "Nakuru", loanId: "LN-4063", totalDue: "KES 20,000", paid: "KES 14,000", balance: "KES 6,000", date: "2026-02-24", status: "Partial" },
];

export default function BranchPartialPaymentsPage() {
  const navigate = useNavigate();
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <button onClick={() => navigate("/reports")} className="p-2 rounded-lg hover:bg-accent transition-colors"><ArrowLeft className="h-5 w-5 text-foreground" /></button>
        <h1 className="text-2xl font-bold text-foreground">Branch Partial Payments</h1>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {[{ title: "Total Partial Payments", value: "5" }, { title: "Total Paid", value: "KES 71,200" }, { title: "Outstanding Balance", value: "KES 30,800" }].map(s => (
          <Card key={s.title}><CardContent className="p-5"><p className="text-sm text-muted-foreground">{s.title}</p><p className="text-2xl font-bold mt-1">{s.value}</p></CardContent></Card>
        ))}
      </div>
      <Card>
        <CardHeader><CardTitle>Partial Payment Records</CardTitle></CardHeader>
        <CardContent>
          <Table>
            <TableHeader><TableRow>
              <TableHead>Customer</TableHead><TableHead>Branch</TableHead><TableHead>Loan ID</TableHead><TableHead>Total Due</TableHead><TableHead>Paid</TableHead><TableHead>Balance</TableHead><TableHead>Date</TableHead><TableHead>Status</TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {data.map(r => (
                <TableRow key={r.loanId}>
                  <TableCell className="font-medium">{r.customer}</TableCell><TableCell>{r.branch}</TableCell><TableCell>{r.loanId}</TableCell><TableCell>{r.totalDue}</TableCell><TableCell>{r.paid}</TableCell><TableCell>{r.balance}</TableCell><TableCell>{r.date}</TableCell>
                  <TableCell><Badge variant="secondary">{r.status}</Badge></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
